export const fonts = {
    primary: 'Montserrat, sans-serif',
    secondary: 'Libre Franklin, sans-serif'
}
